import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

let phoneInstanceCounter = 0;

@Component({
  selector: 'lib-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  standalone: false
})
export class EditPhoneComponent {
  readonly errorId = `phone-error-${++phoneInstanceCounter}`;

  @Input() formGroup: {
    controls: {
      phoneNumber: FormControl<string>;
      phoneNumberRaw: FormControl<string>;
      extension: FormControl<string>;
    };
  };
  @Input() label: string;
  @Input() required: boolean;
  @Input() isSmallLabel: boolean = false;

  displayLabel = () => {
    return this.isSmallLabel ? '' : 'bigLabel';
  };
}

export const cleanPhoneNumber = (formattedNumber: string) => {
  if (!formattedNumber) {
    return formattedNumber;
  }
  const stripped = formattedNumber.replace(/([^\+0-9]+)/g, '');
  return stripped[0] === '+' ? stripped : `+1${stripped}`;
};
